import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import StatsCard from "shared/components/statsCard";
import styles from "./style.module.scss";
import useWindowSize from "shared/customHooks/windowSize";
import classNames from "classnames";
import { Icons, Images } from "assets";
import moment from "moment";
import React, { useEffect, useState } from "react";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import { user_roles } from "shared/utils/constants";
import {
  blockPartnerUser,
  getPartnersListings,
  getPartnersOverallStats,
  unBlockPartnerUser,
} from "shared/services/projectHeadService";
import useDebounce from "shared/customHooks/useDebounce";
import PaginationComponent from "shared/components/pagination";
import Confirmation from "shared/modals/confirmation";
import { toastMessage } from "shared/components/toast";
import Filter from "shared/components/filterButton";
import AnimateLoader from "shared/components/loader/animation";
import { statusFilterOptions } from "./constant";

function PartnersDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const keyword: any = params?.keyword;
  const screenWidth = useWindowSize();
  const [search, setSearch] = useState<string>("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [searchText, setSearchText] = useState<string>("");
  const [stats, setStats] = useState<any>([]);
  const [statsLoader, setStatsLoader] = useState<boolean>(false);
  const [partners, setPartners] = useState<any>([]);
  const [partnersLoader, setPartnersLoader] = useState<boolean>(true);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [activePage, setActivePage] = useState<number>(1);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [actionLoader, setActionLoader] = useState<boolean>(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState<any>(null);
  const [action, setAction] = useState<any>({
    label: "",
    type: "",
  });
  const [selectedItem, setSelectedItem] = useState<any>(null);
  //eslint-disable-next-line
  const [activeRole, setActiveRole] = useState<number | null>(
    keyword === "author"
      ? user_roles.author
      : keyword === "publisher"
      ? user_roles.publisher
      : null
  );

  console.log("activeRole", activeRole);

  let statsCard = [
    {
      label: "New Signed Up Accounts",
      count: stats?.new_signups,
    },
    {
      label: "Approved MOUs",
      count: stats?.accepted_mou,
    },
    {
      label: `MOUs pending from ${keyword} Side`,
      count: stats?.pending_mou,
    },
  ];

  useBreadcrumbs(
    {
      title:
        keyword.charAt(0).toUpperCase() +
        keyword.slice(1).toLowerCase() +
        "s' Detail",
      path: routeConstant.partnersDetail.path.replace(":keyword", keyword),
    },
    true,
    keyword
  );

  ///////

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setSelectedItem(null);
  };

  const handleOpenConfirm = (label: String, type: String, item: any) => {
    setOpenConfirm(true);
    setAction({
      label: label,
      type: type,
    });
    setSelectedItem(item);
  };

  const handleAction = (action: any) => {
    let service =
      action?.type === "deactivate"
        ? blockPartnerUser
        : action?.type === "activate"
        ? unBlockPartnerUser
        : null;
    setActionLoader(true);
    service?.(selectedItem?.id)
      .then(({ data }) => {
        toastMessage("success", data?.message);
        handleCloseConfirm();
        getPartners();
        setActionLoader(false);
      })
      .catch((err) => {
        toastMessage("error", err?.response.data?.message);
        console.log("error", err?.response.data?.message);
        setActionLoader(false);
      });
  };

  const getStats = (allTime?: boolean) => {
    setStatsLoader(true);
    getPartnersOverallStats(Number(activeRole), {
      from: moment(startDate).format("YYYY-MM-DD"),
      to: moment(endDate).format("YYYY-MM-DD"),
    })
      .then(({ data }) => {
        console.log("statsss", data);
        setStats(data?.data);
        setStatsLoader(false);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getPartners = () => {
    setPartnersLoader(true);
    getPartnersListings(
      Number(activeRole),
      selectedStatusFilter,
      activePage,
      searchText,
      {
        from: moment(startDate).format("YYYY-MM-DD"),
        to: moment(endDate).format("YYYY-MM-DD"),
      }
    )
      .then(
        ({
          data: {
            data: { partners },
          },
        }) => {
          console.log("data", partners);
          setPartners(partners?.data);
          setPartnersLoader(false);
          setTotalPage(partners?.last_page);
        }
      )
      .catch((err) => {
        console.log("err", err);
        setPartnersLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getStats();
    }

    //eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      getPartners();
    }

    //eslint-disable-next-line
  }, [startDate, endDate, activePage, searchText, selectedStatusFilter]);

  useDebounce(
    () => {
      const trimmedSearch = search.trim();
      if (trimmedSearch === searchText) return;
      setSearchText(trimmedSearch);
      setActivePage(1);
    },
    [search],
    800
  );

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.headingContainer}>
        <div>
          <span className={styles.heading}>
            Total {stats?.total}{" "}
            {keyword === "publisher"
              ? "Publisher"
              : keyword === "author"
              ? "Author"
              : ""}{" "}
            Account
          </span>
        </div>
        <div>
          <div className={styles.dateContainer}>
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={(date: Date | null) => {
                setEndDate(date);
                setActivePage(1);
              }}
              doubleLabel={true}
            />
          </div>
        </div>
      </Box>

      <StatsCard
        statsList={statsCard}
        loader={statsLoader}
        label={`${
          keyword === "publisher"
            ? "Publisher"
            : keyword === "author"
            ? "Author"
            : ""
        } Stats`}
      />

      <div className={styles.mainTableContainer}>
        <Box className={styles.filterContainer}>
          <div className={styles.userFilter}>
            <Filter
              label="Status"
              filterOption={statusFilterOptions}
              labelStyle={styles.filterStyles}
              selectedOption={selectedStatusFilter}
              setSelectedOption={setSelectedStatusFilter}
              setActivePage={setActivePage}
            />
          </div>
          <div className={styles.gridContainer}>
            <Icons.SearchIcon className={styles.searchIcon} />
            <input
              placeholder="Search"
              className={styles.input}
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
        </Box>

        <TableContainer
          component={Paper}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          className={styles.tableContainer}
          id="table-view-dashboard"
        >
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Joining Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {partnersLoader ? (
                <Loader />
              ) : (
                partners?.map((item: any, index: number, arr: any[]) => {
                  return (
                    <TableRow
                      className={classNames(
                        index + 1 === arr?.length && styles.noBorder
                      )}
                    >
                      {/* <TableCell>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={
                              item?.publisher?.profile_picture
                                ? item?.publisher?.profile_picture
                                : item?.author?.profile_picture
                                ? item?.author?.profile_picture
                                : Images.UserPlaceholderImage
                            }
                            alt="profile_picture"
                            className={styles.profilepic}
                          />
                          <label>
                            {item?.publisher?.full_name
                              ? item?.publisher?.full_name
                              : item?.author?.full_name
                              ? item?.author?.full_name
                              : ""}
                          </label>
                        </div>
                      </TableCell> */}
                      <TableCell
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={
                              item?.publisher?.profile_picture
                                ? item?.publisher?.profile_picture
                                : item?.author?.profile_picture
                                ? item?.author?.profile_picture
                                : Images.UserPlaceholderImage
                            }
                            alt="profile_picture"
                            className={styles.profilepic}
                          />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <label>
                              {item?.publisher?.full_name
                                ? item?.publisher?.full_name
                                : item?.author?.full_name
                                ? item?.author?.full_name
                                : ""}
                            </label>
                            {(item?.publisher?.publishing_house ||
                              item?.author?.publishing_house) && (
                              <label className={styles.publishingHouse}>
                                {item?.publisher?.publishing_house
                                  ? item?.publisher?.publishing_house
                                  : item?.author?.publishing_house
                                  ? item?.author?.publishing_house
                                  : ""}
                              </label>
                            )}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        {item?.email ? item?.email : "Not Provided"}
                      </TableCell>
                      <TableCell>
                        {item?.publisher?.phone
                          ? item?.publisher?.phone
                          : item?.author?.phone
                          ? item?.author?.phone
                          : "Not Provided"}
                      </TableCell>
                      <TableCell>
                        {moment(item?.created_at).format("DD MMM, YYYY")}
                      </TableCell>
                      <TableCell>
                        <div className={styles.actionContainer}>
                          <Tooltip
                            componentsProps={{
                              tooltip: { className: "tooltip" },
                              arrow: { className: "arrow" },
                            }}
                            placement="top"
                            arrow
                            title="View"
                          >
                            <div
                              onClick={() => {
                                navigate(
                                  routeConstant.partnerProfile.path
                                    .replace(":role", "publisher")
                                    .replace(":id", "1")
                                );
                              }}
                            >
                              <Icons.EyeIcon />
                            </div>
                          </Tooltip>

                          <Tooltip
                            componentsProps={{
                              tooltip: { className: "tooltip" },
                              arrow: { className: "arrow" },
                            }}
                            placement="top"
                            arrow
                            title={
                              !item?.is_blocked ? "Deactivate" : "Activate"
                            }
                          >
                            <div
                              onClick={() =>
                                handleOpenConfirm(
                                  `Are you sure, you want to ${
                                    item?.is_blocked ? "activate" : "deactivate"
                                  } this user?`,
                                  `${
                                    item?.is_blocked ? "activate" : "deactivate"
                                  }`,
                                  item
                                )
                              }
                            >
                              {item?.status ? (
                                <Icons.UserDeactivate
                                  className={classNames(
                                    styles.icons,
                                    styles.deactive
                                  )}
                                />
                              ) : (
                                <Icons.UserActivate
                                  className={classNames(
                                    styles.icons,
                                    styles.active
                                  )}
                                />
                              )}
                            </div>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPage > 1 && (
          <div style={{ background: "white" }}>
            <PaginationComponent
              totalPages={totalPage}
              activePage={activePage}
              setActivePage={setActivePage}
            />
          </div>
        )}

        {!(partners?.length > 0) && !partnersLoader && (
          <div className={styles.noUserCard}>
            <Icons.TableEmptyIcon />
            <h5 className={styles.noDataLabel}>No Data Found</h5>
          </div>
        )}
      </div>

      <Confirmation
        text={action.label}
        handleClose={handleCloseConfirm}
        open={openConfirm}
        handleClick={() => handleAction(action)}
      />

      {actionLoader && <AnimateLoader />}
    </div>
  );
}

export default PartnersDetail;

const Loader = () => {
  return (
    <React.Fragment>
      {Array.from({ length: 8 }).map((item, index) => {
        return (
          <TableRow key={index} id={styles.loaderRow}>
            <TableCell>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="rounded" width={100} height={25} />
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={25} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={25} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={129} height={25} />
            </TableCell>

            <TableCell>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Skeleton variant="rounded" width={25} height={25} />
                <Skeleton variant="rounded" width={25} height={25} />
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </React.Fragment>
  );
};
